import { documentResourceToFormValues } from './document-resource-to-form-values';

import type { BankAccountFormValues } from '../../model/schemas';
import type { ApplicationDataResponse } from '../../model/types';

export function recoverBankDetails(
  bankDetails: ApplicationDataResponse['bankDetails']
): BankAccountFormValues | undefined {
  if (!bankDetails) return undefined;

  return {
    providerId: bankDetails.providerId,
    beneficiaryName: bankDetails.beneficiaryName,
    accountNumber: bankDetails.accountNumber,
    proofsOfAccount: bankDetails.proofsOfAccount.map(
      documentResourceToFormValues
    ),
  };
}
